import { render, staticRenderFns } from "./WitHis.vue?vue&type=template&id=54ea4aa2&scoped=true&"
import script from "./WitHis.vue?vue&type=script&lang=js&"
export * from "./WitHis.vue?vue&type=script&lang=js&"
import style0 from "./WitHis.vue?vue&type=style&index=0&id=54ea4aa2&lang=css&scoped=true&"
import style1 from "./WitHis.vue?vue&type=style&index=1&id=54ea4aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea4aa2",
  null
  
)

export default component.exports